import React from 'react';

const security = [
  {
    icon: '🟢',
    color: 'bg-green-100 text-green-600',
    title: 'RGPD',
    desc: 'Conformité totale aux réglementations européennes.',
  },
  {
    icon: '🔒',
    color: 'bg-blue-100 text-blue-600',
    title: 'Chiffrement',
    desc: 'Stockage sécurisé avec chiffrement end-to-end.',
  },
  {
    icon: '🟣',
    color: 'bg-purple-100 text-purple-600',
    title: 'Données privées',
    desc: 'Aucune monétisation de vos informations personnelles.',
  },
];

function Security() {
  return (
    <section className="bg-[#f7fafd] py-20 px-4 md:px-0" id="security">
      <h2 className="text-3xl font-bold text-blue-900 text-center mb-2">Sécurité & Éthique</h2>
      <p className="text-center text-blue-700 max-w-2xl mx-auto mb-10">Vos données sont protégées et privées</p>
      <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        {security.map((s) => (
          <div key={s.title} className="bg-white rounded-2xl shadow p-6 flex flex-col items-center transition-transform duration-300 hover:scale-105 hover:shadow-xl animate-fadeIn">
            <span className={`text-3xl mb-3 w-12 h-12 flex items-center justify-center rounded-full ${s.color}`}>{s.icon}</span>
            <h3 className="font-semibold text-blue-900 mb-1 text-center">{s.title}</h3>
            <p className="text-blue-700 text-center text-sm">{s.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Security; 